export const calendarClasses = {
  containerClasses: 'p-4 bg-white w-fit rounded-lg shadow-dark',
  dayGridClasses: 'grid grid-cols-7 w-56',
  monthTextClasses: 'font-medium flex-1',
  headerClasses: 'pt-0.5 pb-7',
  rowHeaderClasses: 'text-center text-sm select-none h-8 leading-8',
  monthButtonClasses: 'flex-none ml-6 hover:text-primary fill-current',
  monthButtonIconClasses: 'size-6',
  monthGridClasses: 'grid grid-cols-3 w-56',
  menuButtonClasses: 'py-4 hover:text-primary',
  headerButtonClasses: 'hover:text-primary',
};
